import { Box } from '@mui/material'
import {
  useGetProductionCapacity,
  useUpdateProductionCapacity,
  useUploadProductionCapacity,
} from './SystemOfRecords.data'
import { ProductionCapacityTable } from './ProductionCapacity.MUITable'
import { ProductionCapacityRowType } from './SystemOfRecords.types'
import { toast } from 'react-hot-toast'

export const ProductionCapacityView = () => {
  const { data: ProductionCapacity, isLoading } = useGetProductionCapacity()

  const onUpdateSuccess = () => {
    toast.success('Production capacity updated successfully')
  }
  const onUpdateFailure = () => {
    toast.error('Failed to update production capacity')
  }

  const { mutate: saveProductionCapacity, isLoading: isSaving } =
    useUpdateProductionCapacity(onUpdateSuccess, onUpdateFailure)

  const updateTableData = (
    changedRows: Record<number, ProductionCapacityRowType>
  ) => {
    saveProductionCapacity(changedRows)
  }

  // upload
  const { mutate: uploadProductionCapacity, isLoading: isUploading } =
    useUploadProductionCapacity(onUpdateSuccess, onUpdateFailure)

  return (
    <Box
      padding={0}
      marginTop={2}
      sx={{ height: 'calc(100vh - 200px)', minHeight: 0 }}
    >
      <ProductionCapacityTable
        uploadProductionCapacity={uploadProductionCapacity}
        isUploading={isUploading}
        data={ProductionCapacity?.data ?? []}
        isLoading={isLoading}
        updateTableData={updateTableData}
        workCentreCode={ProductionCapacity?.workCentreCode ?? []}
        isSaving={isSaving}
      />
    </Box>
  )
}
